import { render, staticRenderFns } from "./CreatePayment.vue?vue&type=template&id=628c751b&scoped=true"
import script from "./CreatePayment.vue?vue&type=script&lang=ts"
export * from "./CreatePayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c751b",
  null
  
)

export default component.exports